import React from "react";
import { ButtonGroup } from "@mui/material";

import useWindowDimensions from "../hooks/useWindowDimensions";
import FilterButton from "./filterButton";
import { FilterType, PlatformType } from "../types/types";
import useTheme from "../hooks/useTheme";

export default function PlatformFilterButtons(props: {
  filter: FilterType;
  onChange: (filter: FilterType) => void;
  style?: React.CSSProperties;
}) {
  const { isSmallLayout } = useWindowDimensions();

  const theme = useTheme();

  const androidImage: string = theme.images.android;
  const iosImage: string = theme.images.apple;
  const webImage: string = theme.images.web;
  const windowsImage: string = theme.images.windows;

  const styles: {
    platformFilter: React.CSSProperties;
    appleFilter: React.CSSProperties;
  } = {
    platformFilter: {
      height: isSmallLayout ? 25 : 35,
      width: isSmallLayout ? 25 : 35,
    },
    appleFilter: {
      height: isSmallLayout ? 25 : 35,
      width: isSmallLayout ? 20 : 32,
    },
  };

  return (
    <div style={props.style}>
      <ButtonGroup
        variant="contained"
        aria-label="outlined primary button group"
      >
        <FilterButton
          onChange={() =>
            props.onChange({
              erp: props.filter.erp,
              platform: PlatformType.android,
            })
          }
          selected={props.filter.platform === PlatformType.android}
          imageSrc={androidImage}
          imageStyle={styles.platformFilter}
        />
        <FilterButton
          onChange={() =>
            props.onChange({
              erp: props.filter.erp,
              platform: PlatformType.iOS,
            })
          }
          selected={props.filter.platform === PlatformType.iOS}
          imageSrc={iosImage}
          imageStyle={styles.appleFilter}
        />
        <FilterButton
          onChange={() =>
            props.onChange({
              erp: props.filter.erp,
              platform: PlatformType.windows,
            })
          }
          selected={props.filter.platform === PlatformType.windows}
          imageSrc={windowsImage}
          imageStyle={styles.platformFilter}
        />
        <FilterButton
          onChange={() =>
            props.onChange({
              erp: props.filter.erp,
              platform: PlatformType.web,
            })
          }
          selected={props.filter.platform === PlatformType.web}
          imageSrc={webImage}
          imageStyle={styles.platformFilter}
        />
      </ButtonGroup>
    </div>
  );
}
